import ConfigContextProvider, { ConfigContext } from './config-context.provider';

export { ConfigContext };
export default ConfigContextProvider;
